import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { CoreMenuService } from '@core/components/core-menu/core-menu.service';

@Component({
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {
  grpCenterUser: any;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(private _changeDetectorRef: ChangeDetectorRef, private _coreMenuService: CoreMenuService) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const reloaded = urlParams.get('reloaded');
    // Set the menu either from the input or from the service
    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.grpCenterUser = this._coreMenuService.grpCenterUser;
      if (!reloaded) {
        const nuevaUrl = new URL(window.location.href);
        nuevaUrl.searchParams.set('reloaded', 'true');
        window.location.href = nuevaUrl.toString();
        return;
      }
      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();
      this._changeDetectorRef.markForCheck();
    });
  }
  encontrarRol(rol){
    let encontrado = false;
    rol.map(rol=>{
     let rolEncontrado =  this.grpCenterUser.roles.find(x => x.nombre === rol);
      if(rolEncontrado){
        encontrado = true;
      }
    });
    return encontrado;
  }
}
